module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "syn-content"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "60",
      "desktop": "60"
    }
  }, [_c('mu-paper', {
    attrs: {
      "zDepth": 1,
      "rounded": ""
    }
  }, [_c('div', {
    staticClass: "card-toolbar color-black",
    staticStyle: {
      "background-color": "#eeeeee",
      "border": "1px solid #edf1f2"
    }
  }, [_c('span', {
    staticClass: "card-toolbar-title",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "#/scan"
    }
  }, [_vm._v("Colis / code barre")])]), _vm._v(" "), _c('span', [_c('mu-flat-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.saveProgress),
      expression: "!saveProgress"
    }],
    staticStyle: {
      "min-width": "44px"
    },
    attrs: {
      "icon": "picture_as_pdf"
    },
    on: {
      "click": function($event) {
        _vm.printBar()
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "min-width": "44px"
    },
    attrs: {
      "icon": "cached"
    }
  })], 1)]), _vm._v(" "), _c('mu-list', [_vm._l((_vm.barcode), function(item, index) {
    return [(index) ? _c('mu-divider', {
      key: index
    }) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
      key: index,
      attrs: {
        "href": '#/declaration/' + item.fk_soc,
        "title": item.cus_name
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "library_books"
      },
      slot: "left"
    }), _vm._v(" "), _c('mu-badge', {
      attrs: {
        "title": item.borddt,
        "content": item.barcode_scan + ' / ' + item.barcode_count,
        "secondary": ""
      },
      slot: "after"
    })], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "40",
      "desktop": "40"
    }
  }, [_c('mu-paper', {
    attrs: {
      "zDepth": 1
    }
  }, [_c('div', {
    staticClass: "card-toolbar color-black",
    staticStyle: {
      "background-color": "#eeeeee",
      "border": "1px solid #edf1f2"
    }
  }, [_c('span', {
    staticClass: "card-toolbar-title",
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.87)"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "#/invoice"
    }
  }, [_vm._v("Chauffeurs")])]), _vm._v(" "), _c('span', [_c('mu-flat-button', {
    staticStyle: {
      "min-width": "44px"
    },
    attrs: {
      "icon": "cached"
    }
  })], 1)]), _vm._v(" "), _c('mu-list', _vm._l((_vm.driver), function(item, index) {
    return _c('mu-list-item', {
      key: index,
      attrs: {
        "title": item.firstname + ' ' + item.name + ''
      }
    }, [_c('mu-badge', {
      attrs: {
        "content": item.tel1,
        "primary": ""
      },
      slot: "after"
    })], 1)
  }))], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b39d57de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Dashboard.vue
// module id = 472
// module chunks = 1